var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23.563,
    viewBox: "0 0 29 23.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twiiter",
    transform: "translate(0 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315",
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3314",
    "data-name": "Group 3314",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M29,50.789a12.4,12.4,0,0,1-3.426.939,5.912,5.912,0,0,0,2.615-3.286,11.881,11.881,0,0,1-3.77,1.439,5.945,5.945,0,0,0-10.284,4.065,6.122,6.122,0,0,0,.138,1.356A16.828,16.828,0,0,1,2.019,49.084,5.947,5.947,0,0,0,3.846,57.03,5.871,5.871,0,0,1,1.16,56.3v.065A5.973,5.973,0,0,0,5.923,62.2a5.934,5.934,0,0,1-1.559.2,5.257,5.257,0,0,1-1.126-.1A6,6,0,0,0,8.794,66.44a11.946,11.946,0,0,1-7.371,2.536A11.134,11.134,0,0,1,0,68.895a16.738,16.738,0,0,0,9.121,2.668c10.94,0,16.922-9.063,16.922-16.918,0-.263-.009-.517-.022-.768A11.861,11.861,0,0,0,29,50.789Z",
    transform: "translate(0 -48)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.26be1f03df122e495aaec8ac627859c2.svg";
export { ForwardRef as ReactComponent };